<div class="container">
  <div class="row">
    <div class="col">
      <div class="change-password-container" >
        <div class="login-page-logo">
          <img src="assets/images/logo.png"
               srcset="assets/images/logo@2x.png 2x, assets/images/logo@3x.png 3x"
               class="logo" />
        </div>
        <div class="page-title">Change password</div>
        <div class="page-subtitle">
          <span *ngIf="user.userId">Please enter your new password</span> 
          <span *ngIf="!user.userId">Invalid key used, or the key has expired.</span> 

          <!--<div class="invalid-input"
               role="alert"
               *ngIf="responseError && responseError?.error">
            {{ responseError?.error?.message }}
          </div>-->
          <form name="changePasswordForm"
                [formGroup]="changePasswordForm"
                novalidate *ngIf="user.userId">
            <div class="form-group">
              <div class="password">
                <input type="password"
                       class="form-control"
                       placeholder="Password"
                       formControlName="password" />
              </div>
            </div>

            <div class="form-group">
              <div class="password p-0">
                <input type="password"
                       class="form-control"
                       placeholder="Confirm Password"
                       formControlName="confirm" />
              </div>
            </div>

            <button class="btn btn-primary w-100"
                    (click)="submitForm(changePasswordForm.value)"
                    [disabled]="changePasswordForm.invalid || isLoader">
              <!--<i class="fas fa-spinner fa-spin colorWhite" *ngIf="isLoader"></i>-->
              Save New Password
            </button>
          </form>

          <div class="text-center mt-4">
            <a role="button"
               class="link"
               (click)="GoBackToLogin()"
               class="font-weight-500 text-primary">Back to Login</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
